(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.functionallibrary = {}));
}(this, (function (exports) { 'use strict';

  var allAreTrue = function allAreTrue() {
    for (var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++) {
      arg[_key] = arguments[_key];
    }

    return arg.every(function (a) {
      return a;
    });
  };

  var allAreTrue_2 = allAreTrue;
  var allAreTrue_1 = {
    allAreTrue: allAreTrue_2
  };

  var find = function find(fn, col) {
    return col.find(fn);
  };

  var findIndex = function findIndex(fn, col) {
    return col.findIndex(fn);
  };

  var forEach = function forEach(fn, col) {
    return col.forEach(fn);
  };

  var map = function map(fn, col) {
    return col.map(fn);
  };

  var reduce = function reduce(fn, col) {
    var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    return col.reduce(fn, acc);
  };

  var arrayPrototypes = {
    find: find,
    findIndex: findIndex,
    forEach: forEach,
    map: map,
    reduce: reduce
  };

  var atLeastOneTrue = function atLeastOneTrue() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.some(function (a) {
      return a;
    });
  };

  var atLeastOneTrue_2 = atLeastOneTrue;
  var atLeastOneTrue_1 = {
    atLeastOneTrue: atLeastOneTrue_2
  };

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var equality = function equality() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var prop1 = args[0],
        prop2 = args[1];

    if (!prop2) {
      prop2 = prop1;
    }

    return function inner(item) {
      return _typeof(item) === 'object' ? item[prop1] === prop2 : item === prop1;
    };
  }; // const people = [{ id: 1, name: 'Noah' }, { id: 2, name; 'Pepe' }, { id: 3, name: 'Luciana' }, { id: 4, name: 'Jose Juan' }];
  // const noah = people.find(equality('name', 'Noah')); --> noah = { id: 1, name: 'Noah' }


  var equality_2 = equality;
  var equality_1 = {
    equality: equality_2
  };

  var find$1 = arrayPrototypes.find;
  var equality$1 = equality_1.equality;

  var commonsItemsBetweenArrays = function commonsItemsBetweenArrays(collection1, collection2) {
    var _collection = _slicedToArray(collection1, 2),
        arr1 = _collection[0],
        prop1 = _collection[1];

    var _collection2 = _slicedToArray(collection2, 2),
        arr2 = _collection2[0],
        prop2 = _collection2[1];

    var lower = arr1.length <= arr2.length ? arr1 : arr2;
    var bigger = lower.length === arr1.length ? arr2 : arr1;
    var list = [];

    if (prop2) {
      lower.forEach(function (a) {
        var val = prop1 ? a[prop1] : a;
        var match = find$1(equality$1(prop2, val), bigger);

        if (match) {
          list = list.concat(match);
        }
      });
    }

    if (lower.every(function (a) {
      return typeof a === 'string' || typeof a === 'number';
    }) && bigger.every(function (a) {
      return typeof a === 'string' || typeof a === 'number';
    })) {
      lower.forEach(function (a) {
        var match = bigger.find(function (b) {
          return a === b;
        });
        list = match ? list.concat(match) : list;
      });
    }

    return list;
  };

  var commonsItemsBetweenArrays_2 = commonsItemsBetweenArrays;
  var commonsItemsBetweenArrays_1 = {
    commonsItemsBetweenArrays: commonsItemsBetweenArrays_2
  };

  var compose = function compose() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return fns.reduceRight(function (res, fn) {
        return [fn.call.apply(fn, [null].concat(_toConsumableArray(res)))];
      }, args)[0];
    };
  };

  var compose_2 = compose;
  var compose_1 = {
    compose: compose_2
  };

  var getPropertysValue = function getPropertysValue(args) {
    var propFlow = args.split('.');
    return function inner(item) {
      var newItem = _objectSpread2({}, item);

      propFlow.forEach(function (el) {
        newItem = (newItem || {})[el];
      });
      return newItem;
    };
  };

  var getPropertysValue_2 = getPropertysValue;
  var getPropertysValue_1 = {
    getPropertysValue: getPropertysValue_2
  };

  var getPropertyValue = getPropertysValue_1.getPropertyValue;

  var createPropertyByOtherOne = function createPropertyByOtherOne() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var prop1 = args[0],
        prop2 = args[1];
    return function inner(item) {
      var newItem = null;

      if (item.length) {
        var _item = _slicedToArray(item, 1);

        newItem = _item[0];
      } else {
        newItem = _objectSpread2({}, item);
      }

      newItem[prop1] = getPropertyValue(prop2)(newItem);
      return newItem;
    };
  };

  var createPropertyByOtherOne_2 = createPropertyByOtherOne;
  var createPropertyByOtherOne_1 = {
    createPropertyByOtherOne: createPropertyByOtherOne_2
  };

  var debounce = function debounce(fn) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
    // retarda la ejecucion de una funcion
    var timeOut = null;
    return function inner() {
      clearTimeout(timeOut);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      timeOut = setTimeout(fn.bind(this, args), wait);
    };
  };

  var debounce_2 = debounce;
  var debounce_1 = {
    debounce: debounce_2
  };

  var isEmpty = function isEmpty(arg) {
    if (Array.isArray(arg)) {
      return arg.length === 0;
    }

    if (_typeof(arg) === 'object' && arg !== null) {
      return Object.keys(arg).length === 0;
    }

    if (typeof arg === 'string' || typeof arg === 'number') {
      return !arg;
    }

    return !arg;
  };

  var isEmpty_2 = isEmpty;
  var isEmpty_1 = {
    isEmpty: isEmpty_2
  };

  var isEmpty$1 = isEmpty_1.isEmpty;

  var isNotEmpty = function isNotEmpty(arg) {
    return !isEmpty$1(arg);
  };

  var isNotEmpty_2 = isNotEmpty;
  var isNotEmpty_1 = {
    isNotEmpty: isNotEmpty_2
  };

  var mergeObjects = function mergeObjects() {
    for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
      objs[_key] = arguments[_key];
    }

    return Object.assign.apply(Object, [{}].concat(objs));
  };

  var mergeObjects_2 = mergeObjects;
  var mergeObjects_1 = {
    mergeObjects: mergeObjects_2
  };

  var removeItemFromArrayByIndex = function removeItemFromArrayByIndex(index, arr) {
    arr.splice(index, 1);
    return arr;
  };

  var removeItemFromArrayByIndex_2 = removeItemFromArrayByIndex;
  var removeItemFromArrayByIndex_1 = {
    removeItemFromArrayByIndex: removeItemFromArrayByIndex_2
  };

  var findIndex$1 = arrayPrototypes.findIndex;
  var removeItemFromArrayByIndex$1 = removeItemFromArrayByIndex_1.removeItemFromArrayByIndex;

  var removeItemFromArrayByProp = function removeItemFromArrayByProp(prop, val) {
    return function (arr) {
      var index = findIndex$1(function (a) {
        return a[prop] === val;
      }, arr);
      return removeItemFromArrayByIndex$1(index, arr);
    };
  };

  var removeItemFromArrayByProp_2 = removeItemFromArrayByProp;
  var removeItemFromArrayByProp_1 = {
    removeItemFromArrayByProp: removeItemFromArrayByProp_2
  };

  var returnUniqueArraysItems = function returnUniqueArraysItems() {
    var _ref;

    var res = (_ref = []).concat.apply(_ref, arguments);

    var unique = new Set();
    res.forEach(function (item) {
      unique.add(JSON.stringify(item));
    });
    var uniqueParsed = [];
    unique.forEach(function (item) {
      return uniqueParsed.push(JSON.parse(item));
    });
    return [].concat(uniqueParsed);
  };

  var returnUniqueArraysItems_2 = returnUniqueArraysItems;
  var returnUniqueArraysItems_1 = {
    returnUniqueArraysItems: returnUniqueArraysItems_2
  };

  var round = function round(decimal) {
    return function (value) {
      return Number(value.toFixed(decimal));
    };
  };

  var round_2 = round;
  var round_1 = {
    round: round_2
  };

  var setNewProperty = function setNewProperty(property, v) {
    return function (item, index) {
      var a = _objectSpread2({}, item);

      a[property] = typeof v === 'function' ? v(item, index) : v;
      return a;
    };
  };

  var setNewProperty_2 = setNewProperty;
  var setNewProperty_1 = {
    setNewProperty: setNewProperty_2
  };

  var allAreTrue$1 = allAreTrue_1.allAreTrue;
  var find$2 = arrayPrototypes.find,
      findIndex$2 = arrayPrototypes.findIndex,
      forEach$1 = arrayPrototypes.forEach,
      map$1 = arrayPrototypes.map,
      reduce$1 = arrayPrototypes.reduce;
  var atLeastOneTrue$1 = atLeastOneTrue_1.atLeastOneTrue;
  var commonsItemsBetweenArrays$1 = commonsItemsBetweenArrays_1.commonsItemsBetweenArrays;
  var compose$1 = compose_1.compose;
  var createPropertyByOtherOne$1 = createPropertyByOtherOne_1.createPropertyByOtherOne;
  var debounce$1 = debounce_1.debounce;
  var equality$2 = equality_1.equality;
  var getPropertysValue$1 = getPropertysValue_1.getPropertysValue;
  var isEmpty$2 = isEmpty_1.isEmpty;
  var isNotEmpty$1 = isNotEmpty_1.isNotEmpty;
  var mergeObjects$1 = mergeObjects_1.mergeObjects;
  var removeItemFromArrayByIndex$2 = removeItemFromArrayByIndex_1.removeItemFromArrayByIndex;
  var removeItemFromArrayByProp$1 = removeItemFromArrayByProp_1.removeItemFromArrayByProp;
  var returnUniqueArraysItems$1 = returnUniqueArraysItems_1.returnUniqueArraysItems;
  var round$1 = round_1.round;
  var setNewProperty$1 = setNewProperty_1.setNewProperty;
  var wrapper = {
    allAreTrue: allAreTrue$1,
    atLeastOneTrue: atLeastOneTrue$1,
    commonsItemsBetweenArrays: commonsItemsBetweenArrays$1,
    compose: compose$1,
    createPropertyByOtherOne: createPropertyByOtherOne$1,
    debounce: debounce$1,
    equality: equality$2,
    find: find$2,
    findIndex: findIndex$2,
    forEach: forEach$1,
    getPropertysValue: getPropertysValue$1,
    isEmpty: isEmpty$2,
    isNotEmpty: isNotEmpty$1,
    map: map$1,
    mergeObjects: mergeObjects$1,
    reduce: reduce$1,
    removeItemFromArrayByIndex: removeItemFromArrayByIndex$2,
    removeItemFromArrayByProp: removeItemFromArrayByProp$1,
    returnUniqueArraysItems: returnUniqueArraysItems$1,
    round: round$1,
    setNewProperty: setNewProperty$1
  };
  var wrapper_1 = wrapper.allAreTrue;
  var wrapper_2 = wrapper.atLeastOneTrue;
  var wrapper_3 = wrapper.commonsItemsBetweenArrays;
  var wrapper_4 = wrapper.compose;
  var wrapper_5 = wrapper.createPropertyByOtherOne;
  var wrapper_6 = wrapper.debounce;
  var wrapper_7 = wrapper.equality;
  var wrapper_8 = wrapper.find;
  var wrapper_9 = wrapper.findIndex;
  var wrapper_10 = wrapper.forEach;
  var wrapper_11 = wrapper.getPropertysValue;
  var wrapper_12 = wrapper.isEmpty;
  var wrapper_13 = wrapper.isNotEmpty;
  var wrapper_14 = wrapper.map;
  var wrapper_15 = wrapper.mergeObjects;
  var wrapper_16 = wrapper.reduce;
  var wrapper_17 = wrapper.removeItemFromArrayByIndex;
  var wrapper_18 = wrapper.removeItemFromArrayByProp;
  var wrapper_19 = wrapper.returnUniqueArraysItems;
  var wrapper_20 = wrapper.round;
  var wrapper_21 = wrapper.setNewProperty;

  exports.allAreTrue = wrapper_1;
  exports.atLeastOneTrue = wrapper_2;
  exports.commonsItemsBetweenArrays = wrapper_3;
  exports.compose = wrapper_4;
  exports.createPropertyByOtherOne = wrapper_5;
  exports.debounce = wrapper_6;
  exports.default = wrapper;
  exports.equality = wrapper_7;
  exports.find = wrapper_8;
  exports.findIndex = wrapper_9;
  exports.forEach = wrapper_10;
  exports.getPropertysValue = wrapper_11;
  exports.isEmpty = wrapper_12;
  exports.isNotEmpty = wrapper_13;
  exports.map = wrapper_14;
  exports.mergeObjects = wrapper_15;
  exports.reduce = wrapper_16;
  exports.removeItemFromArrayByIndex = wrapper_17;
  exports.removeItemFromArrayByProp = wrapper_18;
  exports.returnUniqueArraysItems = wrapper_19;
  exports.round = wrapper_20;
  exports.setNewProperty = wrapper_21;

  Object.defineProperty(exports, '__esModule', { value: true });

})));



//////////////////
// WEBPACK FOOTER
// ./node_modules/multiselect-dl/node_modules/functionallibrary/dist/functionallibrary.umd.js
// module id = 1267
// module chunks = 1 30